import {
  REQUEST_FOLLOW_USER,
  FAIL_UNFOLLOW_USER,
  REQUEST_UNFOLLOW_USER,
  FAIL_FOLLOW_USER,
  SET_USER_FOLLOW,
  SUCCESS_GET_SUGGESTED_ATHLETES,
  SUCCESS_GET_TEAMMATES,
  SUCCESS_MODAL_GET_SUGGESTED_ATHLETES,
} from 'shared/actionTypes';

const DEFAULT_MAX_WIDGET_DISPLAY = 6;

function combineExcludedAthletes(state = {}, athletes) {
  const excludedIds = state.excludedAthleteIds ? state.excludedAthleteIds : [];
  const newIds = [];
  athletes.forEach(athlete => {
    newIds.push(athlete.feedUserId.relatedId);
  });

  return [...newIds, ...excludedIds];
}

export default function contentFeatureAthletes(state = {}, action) {
  let showTeammates;
  let isFollowing;

  switch (action.type) {
  case SUCCESS_GET_SUGGESTED_ATHLETES:
    const {
      suggestedAthletes,
      maxScore,
    } = action.payload;

    return Object.assign({}, state, {
      excludedAthleteIds: combineExcludedAthletes(state, suggestedAthletes),
      maxScore,
      hasMoreSuggestions: suggestedAthletes.length === DEFAULT_MAX_WIDGET_DISPLAY,
      refreshSuggestedAthletes: false,
      shouldUpdateSuggestions: true,
      suggestedAthletes,
    });
  case SUCCESS_MODAL_GET_SUGGESTED_ATHLETES:
    const {
      modalSuggestedAthletes,
    } = action.payload;
    return Object.assign({}, state, {
      modalSuggestedAthletes,
      isFetchingSuggestions: false,
      shouldUpdateSuggestions: false,
      refreshSuggestedAthletes: false,
    });
  case SUCCESS_GET_TEAMMATES:
    const {
      teammates,
      hasMoreTeammates,
    } = action.payload;
    showTeammates = action.payload.showTeammates;
    return Object.assign({}, state, {
      teammates,
      excludedAthleteIds: combineExcludedAthletes(state, teammates),
      showTeammates,
      hasMoreTeammates,
      isFetchingAthletes: false,
    });
  case REQUEST_FOLLOW_USER:
  case FAIL_UNFOLLOW_USER:
  case REQUEST_UNFOLLOW_USER:
  case FAIL_FOLLOW_USER:
    isFollowing = action.type === REQUEST_FOLLOW_USER || action.type === FAIL_UNFOLLOW_USER;
    // Let flow into SET_USER_FOLLOW for handling
    // eslint-disable-next-line no-fallthrough
  case SET_USER_FOLLOW:
    if (action.type === SET_USER_FOLLOW) {
      isFollowing = action.payload.isFollowing;
    }
    const { feedUserType, feedUserRelatedId } = action.payload;
    const {
      suggestedAthletes: originalAthletes = [],
    } = state;

    const indexOfAthlete = originalAthletes.findIndex(athlete =>
      athlete.feedUserId.type === feedUserType && athlete.feedUserId.relatedId === feedUserRelatedId);

    // Neither was updated
    if (indexOfAthlete === -1) {
      return state;
    }

    let newSuggestedAthletes = state.suggestedAthletes;
    if (indexOfAthlete !== -1) {
      newSuggestedAthletes = [
        ...originalAthletes,
      ];
      newSuggestedAthletes[indexOfAthlete] = {
        ...(originalAthletes[indexOfAthlete]),
        isFollowing,
      };
    }

    return Object.assign({}, state, {
      suggestedAthletes: newSuggestedAthletes,
    });
  default:
    return state;
  }
}
